// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"92d7dc40","389":"d40d82af","453":"39106ce7","732":"89a9215c","857":"905f460e","977":"941a0adf"}[chunkId] + ".chunk.js";
};